import type { FaireProductEntity } from "../../entity_types/product";

export const p_jw7agsw4dh: FaireProductEntity = {
  token: "p_jw7agsw4dh",
  type: "product",
  name: "Moonstone & Golden Sunstone Carved Heart with Stand Gift Set",
  brandToken: "b_hjv6mwysyg",
  brandName: "Unknown Brand",
  imageUrl:
    "https://cdn.faire.com/fastly/1a5fac0d9ad246cbc7ddfa6e5689ceffe214d09264138addb0c123caed233bc4.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/8d93ef3c5a7854ad2e6f429dd7b97fc7ca72b931d9209e659bd10dc09c15b192.jpeg",
    "https://cdn.faire.com/fastly/362668ae419e61a6194c1bb92cf05c626f4e67186ddbe81bc0324bc4cfad68a0.jpeg",
    "https://cdn.faire.com/fastly/59c530159f7495ec62f49f717281d807113d178b33893c99115130407b771501.jpeg",
    "https://cdn.faire.com/fastly/6f78a7ef89e2ab7ad1596063770ba6088abc6c50207a6eb26ccc1b1d7df22f03.jpeg",
  ],
  priceDollars: 20.77,
  description:
    'Moonstone & Golden Sunstone Carved Heart (42.6g/1.8"H) with Stand Gift Set\n\nMoonstone is known to enhance the connection to the divine feminine, increasing feelings of nurturing, spiritual curiosity, and acceptance.\n\nSunstone is known as the stone of confidence. This stone is thought to promote self-esteem, confidence, positive thinking, and self-love. \n\nThis gift set includes:\n\nMoonstone & Golden Sunstone Carved Heart\nAcrylic stand\nSmall Selenite Wand\nCrystal Informational Cards\nHeight: Approximately 1.8 inches\nWeight: Approximately 42.6 grams\n\n*Please note that this is a natural stone, inclusions and variations may differ from the item in the picture.',
  tags: [],
  msrpDollars: 41.54,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-26T22:25:56.544Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
